module.exports = __webpack_public_path__ + "media/images/page/top/top_bg_02-ca3a1c25bd093d2ad48df78556a24a92.png";